import {
	ConfluencePageAri,
	ConfluenceBlogpostAri,
	ConfluenceWhiteboardAri,
	ConfluenceDatabaseAri,
	ConfluenceEmbedAri,
	ConfluenceFolderAri,
} from '@atlassian/ari';

import { ContentType } from './contentTypeConstants.ts';

type ConfluenceContentAriParameters = {
	ari: string;
	resourceType: ContentType;
};
export const getIdFromConfluenceContentAri = ({
	ari,
	resourceType,
}: ConfluenceContentAriParameters) => {
	if (!ari) {
		return null;
	}

	switch (resourceType) {
		case ContentType.PAGE:
			return ConfluencePageAri.parse(ari).pageId;
		case ContentType.BLOGPOST:
			return ConfluenceBlogpostAri.parse(ari).blogpostId;
		case ContentType.WHITEBOARD:
			return ConfluenceWhiteboardAri.parse(ari).whiteboardId;
		case ContentType.DATABASE:
			return ConfluenceDatabaseAri.parse(ari).databaseId;
		case ContentType.EMBED:
			return ConfluenceEmbedAri.parse(ari).embedId;
		case ContentType.FOLDER:
			return ConfluenceFolderAri.parse(ari).folderId;
	}
};
